import { create_UUID } from 'utils/uuidGenerator';

export const POLL_CONTROLS_AND_RESPONSES = 'POLL_CONTROLS_AND_RESPONSES';
export const POLL_DELETED_CONTROLS_AND_RESPONSES =
  'POLL_DELETED_CONTROLS_AND_RESPONSES';
export const POLL_CURVES = 'POLL_CURVES';
export const POLL_TOPONODES = 'POLL_TOPONODES';
export const POLL_DEVICES = 'POLL_DEVICES';
export const POLL_INDENODES = 'POLL_INDENODES';
export const POLL_AGGREGATORS = 'POLL_AGGREGATORS';
export const POLL_INDIVIDUAL_DEVICE = 'POLL_INDIVIDUAL_DEVICE';
export const POLL_INDIVIDUAL_AGGREGATOR = 'POLL_INDIVIDUAL_AGGREGATOR';
export const POLL_INDIVIDUAL_TOPONODE = 'POLL_INDIVIDUAL_TOPONODE';
export const POLL_INDIVIDUAL_INDENODE = 'POLL_INDIVIDUAL_INDENODE';
export const POLL_INDIVIDUAL_CURVE = 'POLL_INDIVIDUAL_CURVE';
export const POLL_TOPONODE_DEFAULT_CONTROL = 'POLL_TOPONODE_DEFAULT_CONTROL';
export const POLL_INDENODE_DEFAULT_CONTROL = 'POLL_INDENODE_DEFAULT_CONTROL';
export const POLL_CONFIGURATION = 'POLL_CONFIGURATION';

export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAIL = 'SUBSCRIBE_FAIL';
export const UNSUBSCRIBE_FAIL = 'UNSUBSCRIBE_FAIL';
export const UPDATE_POLL_LAST_CHANGED_TIME_SUCCESS =
  'UPDATE_POLL_LAST_CHANGED_TIME_SUCCESS';
export const UPDATE_POLL_LAST_CHANGED_TIME_FAIL =
  'UPDATE_POLL_LAST_CHANGED_TIME_FAIL';

const allowedPollTypes = [
  POLL_CONTROLS_AND_RESPONSES,
  POLL_DELETED_CONTROLS_AND_RESPONSES,
  POLL_CURVES,
  POLL_DEVICES,
  POLL_INDENODES,
  POLL_AGGREGATORS,
  POLL_TOPONODES,
  POLL_INDIVIDUAL_DEVICE,
  POLL_INDIVIDUAL_AGGREGATOR,
  POLL_INDIVIDUAL_TOPONODE,
  POLL_INDIVIDUAL_INDENODE,
  POLL_INDIVIDUAL_CURVE,
  POLL_TOPONODE_DEFAULT_CONTROL,
  POLL_INDENODE_DEFAULT_CONTROL,
  POLL_CONFIGURATION
];

/**
 * General Subscription object
 * @param {string} types type of poll
 * @param {object} params endpoint params for endpoint data
 */
const subscription = (subscriber, frequency, types) => {
  return {
    id: create_UUID(),
    types,
    subscriber,
    frequency,
    lastChanged: Date.now()
  };
};

/**
 * start polling for subscription based on parameter pollType
 * @param {string} subscriber Name of control subscribing
 * @param {Array} pollTypes - types of poll
 * @param {number} frequency - milliseconds per poll
 * @param {number} start
 * @param {number} limit
 */
export const subscribe =
  ({ subscriber, pollTypes, frequency = 60000 }) =>
  async (dispatch, getState) => {
    try {
      const subscriptionPolls = [];
      for (let poll of pollTypes) {
        let { type, resourceId } = poll;
        if (!allowedPollTypes.includes(type)) {
          throw new Error('Invalid poll type');
        }
        subscriptionPolls.push({ type, resourceId });
      }
      return dispatch({
        type: SUBSCRIBE_SUCCESS,
        data: subscription(subscriber, frequency, subscriptionPolls)
      });
    } catch (err) {
      return dispatch({ type: SUBSCRIBE_FAIL, err });
    }
  };

/**
 * unsubscribe to poll
 * @param {string} subscriber Name of control subscribing
 * @param {id} id (optional) id of poll
 */
export const unsubscribe =
  (subscriber, id = null) =>
  async (dispatch, getState) => {
    try {
      const polls = getState().polling.polls;
      let filteredPolls = [];
      if (id) {
        filteredPolls = polls.filter(poll => poll.id !== id);
      } else {
        filteredPolls = polls.filter(poll => poll.subscriber !== subscriber);
      }
      if (filteredPolls.length === polls.length) {
        throw new Error(
          `No polls found to unsubribe to for subscriber: ${subscriber}${
            id ? ' and ID: ' + id : ''
          }`
        );
      }

      return dispatch({
        type: UNSUBSCRIBE_SUCCESS,
        data: filteredPolls
      });
    } catch (err) {
      return dispatch({
        type: UNSUBSCRIBE_FAIL,
        err
      });
    }
  };

export const updateLastUpdatedTime =
  (subscriber, id = null) =>
  async (dispatch, getState) => {
    try {
      const polls = getState().polling.polls;
      let updatedPolls = [];
      if (id) {
        updatedPolls = polls.map(poll => {
          if (poll.id === id) {
            return { ...poll, lastChanged: Date.now() };
          }
          return poll;
        });
      } else {
        updatedPolls = polls.map(poll => {
          if (poll.subscriber === subscriber) {
            return { ...poll, lastChanged: Date.now() };
          }
          return poll;
        });
      }
      await dispatch({
        type: UPDATE_POLL_LAST_CHANGED_TIME_SUCCESS,
        data: updatedPolls
      });
      return;
    } catch (err) {
      return dispatch({
        type: UPDATE_POLL_LAST_CHANGED_TIME_FAIL,
        err
      });
    }
  };
